module.exports = __webpack_public_path__ + "img/Sonder2021.b95bfd41.jpg";